import { Vector as VectorLayer } from 'ol/layer'
import { Icon, Style } from 'ol/style'
import circleMarker from '../circle_marker.png'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'

const currentLocationLayer = currentLocation => {
  const source = new VectorSource({
    format: new GeoJSON(),
    features: currentLocation ? new GeoJSON().readFeatures(currentLocation) : []
  })

  const layer = new VectorLayer({
    className: 'currentLocationLayer',
    zIndex: 5,
    source: null,
    style: _.includes(window.location.pathname, 'byggnadsinventering') ? null : new Style({
      image: new Icon({
        anchor: currentLocation ? [60, 60] : [60, 120],
        anchorXUnits: 'pixels',
        anchorYUnits: 'pixels',
        size: [120, 120],
        scale: 0.4,
        src: currentLocation
          ? circleMarker
          : 'https://cdn.mapmarker.io/api/v1/pin?size=120&background=%23288281&icon=fa-circle&color=%23FFFFFF&voffset=0&hoffset=1'
      })
    })
  })

  layer.setSource(source)

  return layer
}

export default currentLocationLayer
